import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Heuristic } from '../../jscaip/AI/Heuristic';
import { Player } from '../../jscaip/Player';
import { SiamRules } from './SiamRules';
export class SiamHeuristic extends Heuristic {
    getBoardValue(node, config) {
        const boardValueInfo = this.getBoardValueInfo(node.gameState, config);
        return BoardValue.of(boardValueInfo.boardValue);
    }
    getBoardValueInfo(state, config) {
        const mountainsInfo = SiamRules.get().getMountainsRowsAndColumns(state);
        const mountainsRow = mountainsInfo.rows;
        const mountainsColumn = mountainsInfo.columns;
        const pushers = SiamRules.get().getPushers(state, mountainsColumn, mountainsRow, config);
        let zeroShortestDistance = Number.POSITIVE_INFINITY;
        let oneShortestDistance = Number.POSITIVE_INFINITY;
        const currentPlayer = state.getCurrentPlayer();
        for (const pusher of pushers) {
            if (state.isOnBoard(pusher.coord)) {
                const piece = state.getPieceAt(pusher.coord);
                if (piece.belongsTo(Player.ZERO)) {
                    zeroShortestDistance = Math.min(zeroShortestDistance, pusher.distance);
                }
                else {
                    oneShortestDistance = Math.min(oneShortestDistance, pusher.distance);
                }
            }
            else {
                if (currentPlayer === Player.ZERO) {
                    zeroShortestDistance = Math.min(zeroShortestDistance, pusher.distance);
                }
                else {
                    oneShortestDistance = Math.min(oneShortestDistance, pusher.distance);
                }
            }
        }
        const boardValue = SiamRules.get().getScoreFromShortestDistances(zeroShortestDistance, oneShortestDistance, currentPlayer);
        return { shortestZero: zeroShortestDistance, shortestOne: oneShortestDistance, boardValue };
    }
}
